export default function saveDesignersKlaviyo(designers) {
  const { listId, publicApiKey, email } = window.followDesigners;

  if (!listId || !publicApiKey || !email) {
    const message = 'Missing follow designers list ID, api key, or email';
    console.warn(message);
    return Promise.resolve(message);
  }

  const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${publicApiKey}`;

  const options = {
    method: 'POST',
    headers: { revision: '2024-02-15', 'content-type': 'application/json' },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Follow designers',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                properties: { followDesigners: designers }
              },
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    })
  };

  return fetch(url, options)
    .then(res => res.text());
}
